import { IProjectNotification } from './types';
import { useGetUnviewedCountsQuery } from 'redux-store/api/projects';
import { NotificationButton } from 'components/badges/notification-button';
import { AlertButton } from 'components/badges/alert-button';
import { ActivityButton } from 'components/badges/activity-button';
import { getBadgesPermissions } from 'components/badges/utils';
import { useGetCompanyRolePermissionsMeQuery } from 'redux-store/api/company-roles';

export const ProjectNotification = ({ projectId }: IProjectNotification) => {
  const { data: userPermissions } = useGetCompanyRolePermissionsMeQuery();

  const { data: unviewedItems } = useGetUnviewedCountsQuery(
    { projectIds: [projectId] },
    { skip: !Number.isInteger(projectId) }
  );

  const { messages, notifications, overdue, unviewedOverdue } =
    unviewedItems?.items?.[projectId] || {};

  const { isActivityButtonShow, isNotificationButtonShow, isAlertButtonShow } =
    getBadgesPermissions(userPermissions);

  return (
    <>
      {isActivityButtonShow && (
        <ActivityButton projectId={projectId} unviewedItemsCount={messages} />
      )}
      {isNotificationButtonShow && (
        <NotificationButton projectId={projectId} unviewedItemsCount={notifications} />
      )}
      {isAlertButtonShow && (
        <AlertButton
          itemsCount={overdue}
          unviewedItemsCount={unviewedOverdue}
          projectId={projectId}
        />
      )}
    </>
  );
};
